import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';

export const selectOpenSubmissionssWidgetsState = (state: State) =>
    selectWidgetInstancesState(state).openSubmissions;

export const selectOpenSubmissionsState = (state: State, widgetKey: string) =>
    selectOpenSubmissionssWidgetsState(state)[widgetKey];
